// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AzureDevopsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 16 16">
    <path
      fill="url(#azure-devops_svga)"
      d="M15 3.62v8.51L11.5 15l-5.42-1.97v1.95L3 10.97l8.96.7V4.01zm-2.98.43L6.99 1v2L2.4 4.36 1 6.13v4.03l1.98.87V5.87z"
    />
    <defs>
      <linearGradient
        id="azure-devops_svga"
        x1={8}
        x2={8}
        y1={14.96}
        y2={1.03}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0078D4" />
        <stop offset={0.16} stopColor="#1380DA" />
        <stop offset={0.53} stopColor="#3C91E5" />
        <stop offset={0.82} stopColor="#559CEC" />
        <stop offset={1} stopColor="#5EA0EF" />
      </linearGradient>
    </defs>
  </svg>,
  "AzureDevops",
);
export default AzureDevopsIcon;
